import { LegacyPage, Json, Markdown } from 'peach/components'

import { useIsSessionActive } from 'core/auth/authStore'
import { R } from 'core/helpers'
import { useCustomEnvs, useActiveEnv } from 'core/stores/env'

import EnvTable from '../env/EnvTable'

import environments from './environments.md'

const Environments = () => {
  const customEnvs = useCustomEnvs()
  const activeEnv = useActiveEnv()

  const isSessionActive = useIsSessionActive()

  return (
    <LegacyPage.Centered>
      {customEnvs.map((env) => (
        <EnvTable env={env} isActive={env.id === activeEnv?.id} key={env.id} />
      ))}
      {R.isEmpty(customEnvs) ? (
        <Markdown url={environments} />
      ) : (
        <Json.Table
          json={{ isSessionActive, activeEnv }}
          title='Current Auth & Env State'
        />
      )}
    </LegacyPage.Centered>
  )
}

export default Environments
